module.exports = __webpack_public_path__ + "static/media/all.1d3ca507.svg";